import { useEffect } from 'react'

const META_PIXEL_ID = '3215564428623916'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

export function initMetaPixel() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  window.fbq('init', META_PIXEL_ID)
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (window.fbq) {
    window.fbq('track', eventName, params)
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initMetaPixel()
    trackEvent('PageView')
  }, [])

  return { trackEvent }
}
